import { RouteConfig } from 'vue-router';

import PageInvoiceConfiguration from './PageBillingConfiguration.vue';

export default {
  path: 'configuration',
  name: 'billingConfiguration',
  component: PageInvoiceConfiguration,
  meta: {
    title: 'Régua de cobrança',
  },
} as RouteConfig;
